import React, { ReactElement, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CheckBox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '25ch',
  },
  field: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  }
}));

export interface CertificateGenerationsFilterData {
  accreditationCode?: string
  registeredPersonNumber?: number
  generationYear?: number
  containsErrors?: boolean
}
interface CertificateGenerationsFilterProps {
  filter: CertificateGenerationsFilterData
  setFilter: React.Dispatch<React.SetStateAction<CertificateGenerationsFilterData>>
}

const CertificateGenerationsFilterForm: React.FC<CertificateGenerationsFilterProps> = ({ setFilter }): React.ReactElement => {
  const { register, handleSubmit, formState: { errors } } = useForm<CertificateGenerationsFilterData>();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Paper variant="outlined">
          <div className={classes.root}>
            <form noValidate autoCorrect="off" onSubmit={handleSubmit(setFilter)}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  id="accreditationCode"
                  label="Accreditation Code"
                  name="accreditationCode"
                  className={classes.textField}
                  inputRef={register}
                />
              </Grid>
              <TextField
                variant="outlined"
                margin="normal"
                id="generationYear"
                label="Generation Year"
                type="number"
                name="generationYear"
                className={classes.textField}
                inputRef={register({
                  min: {
                    value: 2001,
                    message: 'Value should be at least 2001',
                  },
                })}
                error={errors?.generationYear ? true : false}
                helperText={errors?.generationYear?.message}
              />
              <Grid item xs={12}>

                <TextField
                  variant="outlined"
                  margin="normal"
                  id="registeredPersonNumber"
                  type="number"
                  label="RPN"
                  name="registeredPersonNumber"
                  className={classes.textField}
                  inputRef={register}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  className={classes.field}
                  control={
                    <CheckBox
                      id="containsErrors"
                      name="containsErrors"
                      inputRef={register}
                    />
                  }
                  label="Errors"
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  className={classes.field}
                  variant="contained"
                  color="primary"
                >
                  Filter
              </Button>
              </Grid>
            </form>
          </div>
        </Paper >
      </Grid >
    </div>
  )
}

CertificateGenerationsFilterForm.propTypes = {
  filter: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired
}


export default CertificateGenerationsFilterForm;
